import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/footer";
import "../../css/TermsCondition.css";
import { Helmet } from "react-helmet-async";

export default function TermsCondition() {
  const location = useLocation();
  const sections = [
    {
      title: "1. Use of Services",
      content: [
        "1.1 Eligibility: You must be at least 18 years old to use our services. By using our services, you represent and warrant that you are at least 18 years old.",
        "1.2 Account: Some services may require you to create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account."
      ]
    },
    {
      title: "2. Intellectual Property",
      content: [
        "2.1 Ownership: All content, including but not limited to text, graphics, logos, images, and software, available on our Website is the property of Robotico Digital or its licensors and is protected by intellectual property laws.",
        "2.2 License: Subject to these Terms, we grant you a limited, non-exclusive, non-transferable license to use our services for your personal or internal business purposes."
      ]
    },
    {
      title: "3. Prohibited Activities",
      content: [
        "You agree not to:",
        "• Use our services for any unlawful purpose.",
        "• Attempt to gain unauthorized access to our systems or networks.",
        "• Interfere with the proper functioning of our services.",
        "• Modify, adapt, translate, reverse engineer, or decompile any portion of our Website."
      ]
    },
    {
      title: "4. Privacy",
      content: [
        "4.1 Our Privacy Policy governs the collection, use, and disclosure of your personal information. By using our services, you consent to the collection and use of your personal information as described in our Privacy Policy."
      ]
    },
    {
      title: "5. Disclaimer of Warranties",
      content: [
        '5.1 Our services are provided on an "as is" and "as available" basis without any warranties, express or implied. We do not warrant that our services will be uninterrupted, secure, or error-free.'
      ]
    },
    {
      title: "6. Limitation of Liability",
      content: [
        "6.1 In no event shall Robotico Digital be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or in connection with your use of our services."
      ]
    },
    {
      title: "7. Indemnification",
      content: [
        "7.1 You agree to indemnify and hold harmless Robotico Digital, its affiliates, officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses arising out of or in connection with your use of our services."
      ]
    },
    {
      title: "8. Governing Law",
      content: [
        "8.1 These Terms shall be governed by and construed in accordance with the laws of Karnataka, India, without regard to its conflict of law provisions."
      ]
    },
    {
      title: "9. Changes to Terms",
      content: [
        "9.1 We reserve the right to modify or update these Terms at any time without prior notice. Your continued use of our services after any changes to these Terms constitutes acceptance of such changes."
      ]
    },
    {
      title: "10. Contact Us",
      content: [
        <>
          10.1 If you have any questions or concerns about these Terms, please write to us at{" "}
          <a href="mailto:info@roboticodigital.com" className="email-link">
            info@roboticodigital.com
          </a>{" "}
          or refer to our contact page for more details.
        </>
      ]
    }
  ];

  return (
    <>
    <Helmet>
  <title>
    Terms & Conditions | Froth TestOps
  </title>

  <meta
    name="description"
    content="Review the terms and conditions for using Froth TestOps. Understand your rights, responsibilities, and the rules that govern our services."
  />

  <link
    rel="canonical"
    href="https://frothtestops.com/term-condition"
  />
</Helmet>
    <div className={`fd-main-wrapper ${location.pathname !== "/" ? "page-padding" : ""}`}>
      <Header />
      <main className="terms-container">
      <h1 className="terms-title">Terms & Conditions</h1>
      <h2 className="terms-subtitle">Read terms for clarity</h2>

      {sections.map((section, index) => (
        <section key={index} className="terms-section">

          <div className="terms-grid">
            <p className="terms-heading">{section.title}</p>

            <ul className="terms-list">
              {section.content.map((point, idx) => (
                <li key={idx}>
                  {typeof point === "string" ? point : point}
                </li>
              ))}
            </ul>
          </div>

          {index < sections.length - 1 && (
            <hr className="terms-divider" />
          )}

        </section>
      ))}
        </main>
      <Footer />
    </div>
    </>
  );
}